import { render, staticRenderFns } from "./BoxOptions.vue?vue&type=template&id=0e8d668d&scoped=true&"
import script from "./BoxOptions.vue?vue&type=script&lang=js&"
export * from "./BoxOptions.vue?vue&type=script&lang=js&"
import style0 from "./BoxOptions.vue?vue&type=style&index=0&id=0e8d668d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d668d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8d668d')) {
      api.createRecord('0e8d668d', component.options)
    } else {
      api.reload('0e8d668d', component.options)
    }
    module.hot.accept("./BoxOptions.vue?vue&type=template&id=0e8d668d&scoped=true&", function () {
      api.rerender('0e8d668d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BoxOptions.vue"
export default component.exports